module.exports = __webpack_public_path__ + "static/media/k.37bbff97.m4a";